import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";

const WishlistTour = (props) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  console.log(props.tour);
  return (
    <div className="hotel-list">
      <div className="place-item mb-4">
        <div className="place-img">
          <Carousel
            responsive={responsive}
            autoPlay={true}
            autoPlaySpeed={3000}
            infinite={true}
            arrows={true}
          >
            {props.tour.imageUrls.map((imageUrl, index) => (
              <div key={index}>
                <a href="hotel-details.html">
                  <img
                    src={imageUrl}
                    className="img-fluid"
                    alt={`Tour Image ${index + 1}`}
                  />
                </a>
              </div>
            ))}
          </Carousel>
          <div
            className="fav-item"
            onClick={() => props.onToggleWishlist(props.tour.tourId)}
          >
            <a
              href="#"
              className={`fav-icon ${props.isWishlisted ? "selected" : ""}`}
              onClick={(e) => e.preventDefault()}
            >
              <i className="isax isax-heart5"></i>
            </a>
            <span className="badge bg-info d-inline-flex align-items-center">
              <i className="isax isax-ranking me-1"></i>Trending
            </span>
          </div>
        </div>
        <div className="place-content pb-1">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <div>
              <h5 className="mb-1 text-truncate">
                <Link to={`/tour-detail/${props.tour.tourId}`}>
                  {props.tour.tourName}
                </Link>
              </h5>
              {/* <p className="d-flex align-items-center mb-2">
                <i className="isax isax-location5 me-2"></i>Ciutat Vella,
                Barcelona
              </p> */}
            </div>
            <div className="d-flex align-items-center mb-2">
              <a
                href="#"
                className="d-flex align-items-center overflow-hidden border-end pe-2 me-2"
              >
                <span className="avatar avatar-md flex-shrink-0 me-2">
                  <img
                    src={props.userInfo ? props.userInfo.imageUrl : ""}
                    className="rounded-circle"
                    alt="img"
                  />
                </span>
                /
                <p className="fs-14 text-truncate">
                  {props.userInfo ? props.userInfo.fullName : ""}
                </p>
              </a>
              <div className="d-flex align-items-center text-nowrap">
                <span className="badge badge-warning badge-xs text-gray-9 fs-13 fw-medium me-2">
                  {props.tour.averageRating !== null
                    ? props.tour.averageRating.toFixed(1)
                    : "0"}
                </span>
                <p className="fs-14">({props.tour.reviewCount} đánh giá)</p>
              </div>
            </div>
          </div>
          <p className="line-ellipsis fs-14">{props.tour.description}</p>
          <div className="d-flex align-items-center justify-content-between flex-wrap border-top pt-3">
            <h6 className="d-flex align-items-center mb-3">
              Facillities :
              <i className="isax isax-home-wifi ms-2 me-2 text-primary"></i>
              <i className="isax isax-scissor me-2 text-primary"></i>
              <i className="isax isax-profile-2user me-2 text-primary"></i>
              <i className="isax isax-wind-2 me-2 text-primary"></i>
              <a
                href="#"
                className="fs-14 fw-normal text-default d-inline-block"
              >
                +2
              </a>
            </h6>
            <h5 className="text-primary text-nowrap me-2 mb-3">
              {props.tour.price.toLocaleString("vi-VN", {
                style: "currency",
                currency: "VND",
              })}{" "}
              {/* <span className="fs-14 fw-normal text-default">/ Night</span> */}
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WishlistTour;
